module.exports = __webpack_public_path__ + "img/etiquetas.77076472.svg";